import React, { useEffect, useRef, useState } from 'react';

const FloatTabSelector = ({ options = [], title, onChange = () => {} }) => {
  const [selected, setSelected] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const selectorRef = useRef(null);

  const [position, setPosition] = useState({
    x: window.innerWidth - 240,
    y: window.innerHeight / 2 - 50
  });

  const [dragging, setDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  // ✅ Solo inicializa una vez al montar
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (options.length > 0 && !hasInitialized.current) {
      setSelected(options[0]);
      // ❌ No llamamos onChange automáticamente
      hasInitialized.current = true;
    }
  }, [options]);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (dragging) {
        setPosition({
          x: e.clientX - offset.x,
          y: e.clientY - offset.y
        });
      }
    };

    const handleMouseUp = () => setDragging(false);

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [dragging, offset]);

  const startDragging = (e) => {
    if (selectorRef.current) {
      const rect = selectorRef.current.getBoundingClientRect();
      setOffset({
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      });
      setDragging(true);
    }
  };

  const handleSelect = (value) => {
    setSelected(value);
    onChange(value);
    setIsOpen(false);
  };

  return (
    <div
      ref={selectorRef}
      className="absolute w-56 bg-white border border-gray-300 rounded-lg shadow-lg z-50 cursor-move"
      style={{ left: position.x, top: position.y }}
      onMouseDown={startDragging}
    >
      {/* Título */}
      <div className="px-4 py-2 bg-bluesens text-white font-semibold rounded-t-lg">
        {title || 'Selector'}
      </div>

      {/* Valor seleccionado */}
      <div
        className="px-4 py-2 bg-white cursor-pointer border-t"
        onClick={() => setIsOpen(!isOpen)}
      >
        {selected || 'Seleccione una opción'}
      </div>

      {/* Opciones */}
      {isOpen && (
        <ul className="list-none p-0 m-0 max-h-60 overflow-auto border-t border-gray-200">
          {options.map((opt) => (
            <li
              key={opt}
              onClick={() => handleSelect(opt)}
              className="px-4 py-2 hover:bg-blue-100 cursor-pointer transition"
            >
              {opt}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default FloatTabSelector;
